import React, {createContext, useContext, useState, useCallback} from "react";
import {Mp3Player} from "../Components/Mp3Player/Mp3Player";
const Mp3PlayerContext = createContext({});

export default function Mp3PlayerProvider({children}) {
  const [mp3Open, mp3SetOpen] = useState(false);
  const [mp3Title, setMp3Title] = useState();
  const [mp3, setMp3] = useState();

  const updateMp3 = useCallback((mp3, title) => {
    const update = async () => {
      mp3SetOpen(false);
      setMp3Title(title);
      setMp3(mp3);
      mp3SetOpen(true);
    };
    update();
  }, []);

  return (
    <Mp3PlayerContext.Provider value={{updateMp3, mp3Open}}>
      {children}
      <Mp3Player mp3Open={mp3Open} mp3SetOpen={mp3SetOpen} mp3={mp3} title={mp3Title} />
    </Mp3PlayerContext.Provider>
  );
}

export const useMp3Player = () => useContext(Mp3PlayerContext);
